import React, { useMemo } from "react";
import { ListProps } from "../../servers";
import style from "./index.module.scss";
import VideoLocalPlayer from "./Components/VideoLocalPlayer";
import DocViewer from "./Components/DocViewer";
import HtmlView from "./Components/HtmlView";
import { Empty } from "antd";
import VideoViewer from "./Components/VideoViewer";

interface Props {
    data: ListProps;
    FILETYPE_LIST: Record<string, string[]>;
}
export default function Viewer({ data, FILETYPE_LIST }: Props) {
    type keyType = keyof typeof FILETYPE_LIST;
    const fileType = useMemo((): string => {
        for (let type of Object.keys(FILETYPE_LIST)) {
            if (
                FILETYPE_LIST[type as keyType].includes(
                    data?.fileType?.toLowerCase()
                )
            ) {
                return type;
            }
        }
        return "";
    }, [data]);

    const viewUrl = useMemo(() => {
        if (["ppt", "word", "excel", "pdf"].includes(fileType)) {
            return data?.viewUrl || "";
        } else {
            return data?.fileUrl || "";
        }
    }, [data, fileType]);
    return (
        <div className={style.root}>
            {fileType === "video" && viewUrl.includes("http") && (
                <VideoLocalPlayer src={viewUrl} />
            )}
            {fileType === "video" && !viewUrl.includes("http") && (
                <VideoViewer vid={viewUrl} />
            )}
            {["ppt", "word", "excel", "pdf", "pic"].includes(fileType) && (
                <DocViewer src={viewUrl} />
            )}
            {["href", "polyv"].includes(fileType) && (
                <HtmlView key={viewUrl} src={viewUrl} />
            )}
            {![
                "ppt",
                "word",
                "excel",
                "pdf",
                "pic",
                "href",
                "polyv",
                "video"
            ].includes(fileType) && (
                <div className={style.center}>
                    <Empty description="当前文件格式不支持预览，请下载到本地查看" />
                </div>
            )}
        </div>
    );
}
